const theme = {
  color: {
    pri: "#EF202A",
    whi: "#FFFFFF",
    bg: "#F4EFE9",
    catRg: "linear-gradient(90deg, rgba(255,115,0,1) 0%, rgba(255,255,0,1) 100%)",
  },
};

export default theme;
